import { createSlice, PayloadAction,createAsyncThunk} from "@reduxjs/toolkit";
import { RootState } from "../store";
import apiClient from "../api/clientAdmin";

export const requestSignupKey = createAsyncThunk('admin/createsignupkey', async (reqData: string, { rejectWithValue }) => {
    try {
        const response = await apiClient.post('admin/createsignupkey', reqData, 
        {
            headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem("access_token")
          }
        }
        );
        return response.data
    }
    catch (err) {
        let error:any = err // cast the error for access
        if (!error.response.data) {
          throw err
        }
        // We got validation errors, let's return those so we can reference in our component and set form errors
        return rejectWithValue(error.response.data.message)
        }
});
export const requestReset = createAsyncThunk('admin/resetsystem', async (reqData: string, { rejectWithValue }) => {
    try {
        const response = await apiClient.post('admin/resetsystem', reqData, 
        {
            headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem("access_token")
          }
        });
        return response.data
    }
    catch (err) {
        let error:any = err // cast the error for access
        if (!error.response.data) {
          throw err
        }
        // We got validation errors, let's return those so we can reference in our component and set form errors
        return rejectWithValue(error.response.data.message)
        }
});



interface AdminState {
    signupKey: string, 
    error: any,
    status: string, 
}

// Below we set up our initial state. Feel free to add more if you'd like more information about users to be shown, for instance a biography.
const initialState: AdminState = {
    signupKey: '',
    status : 'idle',
    error : ''
}

export const adminSlice = createSlice({
    name: 'adminPanel',
    initialState,
    reducers: {
        setkey: (state, action:PayloadAction<string>) => {
            state.signupKey = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(requestSignupKey.pending, (state)=>{
            state.status = 'getting signup key';
        })
        builder.addCase(requestSignupKey.fulfilled, (state, action) => {
            state.status = '';
            state.error = '';
            state.signupKey = action.payload.message;

        })
        builder.addCase(requestSignupKey.rejected, (state,action) => {
            state.status = '';
            state.signupKey = ""
            if (action.payload) {
                state.error = action.payload;
              } else {
                state.error = action.error.message;
              }
        })
        builder.addCase(requestReset.pending, (state)=>{
            state.status = 'Resetting system';
        })
        builder.addCase(requestReset.fulfilled, (state, action) => {
            state.error = '';
            state.status = action.payload.message;
        })
        builder.addCase(requestReset.rejected, (state, action) => {
            state.status = '';
            if (action.payload) {
                state.error = action.payload;
              } else {
                state.error = action.error.message;
              }
        })

    },
})

export const {setkey} = adminSlice.actions

export const selectAdmin = (state:RootState) => state.adminPanel;

export default adminSlice.reducer
